<template>
  <div>
    <!-- todo: can we move this to /includes? -->
    <div
      v-for="(error, index) in $store.state.errors[this.type]"
      v-bind:key="index"
      :class="classObject(error)"
      role="alert"
    >
      <div :class="iconObject(error)" v-if="error" />
      <div data-message-type="error" v-html="error.message" />
    </div>
  </div>
</template>

<script>
export default {
  name: 'Errors',
  props: {
    type: { type: String }
  },
  methods: {
    classObject (error) {
      return [
        'alert mt-2 d-flex',
        'alert-' + error.variant
      ]
    },
    iconObject (error) {
      if (error.icon.length) {
        return ['fa mr-3 mt-1', error.icon, 'text-' + error.variant]
      }
    },
    onlineHandler: function () {
      this.$store.commit('errors/REMOVE_ERROR', { code: '000' })
    },
    offlineHandler: function () {
      var error = {
        type: 'general',
        icon: 'fa-plug',
        message: 'You are offline. Please check that you are connected to the internet.', // text or html
        id: '',
        code: '000',
        variant: 'danger' // warn, info, danger
      }

      this.$store.commit('errors/PUSH_ERROR', error)
    }
  },
  created: function () {
    window.addEventListener('online', this.onlineHandler)
    window.addEventListener('offline', this.offlineHandler)
  },
  destroyed: function () {
    window.removeEventListener('online', this.onlineHandler)
    window.removeEventListener('offline', this.offlineHandler)
  }
}
</script>

<style lang="scss" scoped>
  @import "../assets/lib";

  div[role=alert] {
    display: flex;
    align-items: center;
  }
</style>

<docs>
## Component properties
```
<error-container v-bind:type="'general'"></error-container>
```
In this example it will pull the array of general errors.

## error object
You should pass an error to the notifier that looks like this.

```
var error = {
  type: 'general',
  icon: 'fa-exclamation-triangle', // Accepts fontawesome 4 icon names.
  message: 'You are offline. Please check that you are connected to the internet.', // text or html
  id: '',
  code: '000',
  variant: 'danger' // warn, info, danger
}
While all of the params are optional (they have a default value), please set them.

// Example usage in a .vue module
this.$store.commit('errors/PUSH_ERROR', error)
this.$store.commit('errors/PUSH_ERROR', {message: 'General Error'})
this.$store.commit('errors/PUSH_ERROR', {message: 'Couldn\'t find the page', code: 404, icon: 'fa fa-search'})

// Example usage in the $store
var vm = this
vm.commit('errors/PUSH_ERROR', {message: error.message, code: 999})
```

## Add a new Error location
General errors go at the top of the page, but what if you need to put an error someplace else like under a promo code input?

in store/modules/errors.js add a new empty array to `const state`
in the same file add an empty array to the `mutation` `CLEAR_ERRORS`

# Types of errors / Error Locations

### onlineHandler/offlineHandler
Let's the user know when they are offline. (if `navigator.onLine` supported by by the browser)

### Invalid Promo Code (shows under the promo code area of cart and checkout)
</docs>
